export default {
  case_unavailable: 'Judgment does not exist.',
  legis_unavailable: 'Legislation does not exist.',
  page_unavailable: 'This page does not exist.',
  notfound: 'Not Found',
  bad_query: 'There was an error performing your search.',
  noresult_warn: 'No results matched your search criteria',
  nodata_warn: 'No document avaliable',
  error: [
    'Please try searching in our search bar below, or {0} for support.'
  ],
  case_onlyword: 'Only the Word format is available at the moment.',
}